import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ExperimentContentComponent } from '@components/experiment-content/experiment-content.component';
import { RunExperimentModule } from '../run-experiment/run-experiment.module';

@NgModule({
    declarations: [ExperimentContentComponent],
    exports: [ExperimentContentComponent],
    imports: [MatButtonModule, MatCardModule, RunExperimentModule]
})
export class ExperimentContentModule { }